import { api } from './api';
import { TimelineCollectionEntry } from '../types';

export const timelineCollectionsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getTimelineCollections: builder.query<{ data: TimelineCollectionEntry[] }, string>({
			query: (timelineId) => ({
				url: `timelines/${timelineId}/collections`,
				method: 'GET',
			}),
		}),
	}),
});

export const { useGetTimelineCollectionsQuery } = timelineCollectionsApi;
